import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";

import { StocksQuery } from "../../../graphql/deliveryService/queries/stocks";
import { StockOverviewPagedFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";

interface StockSearchQueryProps {
  dataAction: (data: StockOverviewPagedFragment) => void;
  errorAction?: () => void;
}

const useStockSearchQuery = (props: StockSearchQueryProps) => {
  const { dataAction, errorAction } = props;

  const query = useLazyQuery(StocksQuery as any, {
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: "network-only",
  });

  const { data, error } = query[1];

  const stocksPagedFragment = data?.stocks;

  useEffect(() => {
    if (!error) return;
    if (errorAction) {
      errorAction();
    }
  }, [error, errorAction]);

  useEffect(() => {
    if (!data || !stocksPagedFragment) return;
    dataAction(stocksPagedFragment);
  }, [data, dataAction, stocksPagedFragment]);

  return query;
};

export default useStockSearchQuery;
